import axios from 'axios'
import API from './index'

export default {
  get() {
    const url = API.BASE_URL + 'Members'
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
  },

  getMember(memberId) {
    const url = API.BASE_URL + 'Members/' + memberId
    return axios
      .get(url, {
      })
      .then(response => {
        return response.data
      })
  },
  create(member) {
    const url = API.BASE_URL + 'Members'
    return axios
      .post(url, member)
      .then(response => {
        return response
      })
  },

  update(member) {
    const url = API.BASE_URL + 'Members/' + member.memberId
    return axios
      .put(url, member)
      .then(response => {
        return response
      })
  },

  delete(id) {
    const url = API.BASE_URL + 'Members/' + id
    return axios
      .delete(url, {})
      .then(response => {
        return response
      })
  },
}
